import { useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ContentProvider } from '../contexts/ContentContext';
import { MediaProvider } from '../contexts/MediaContext';
import { SocialHighlights } from '../components/SocialHighlights';

export const SocialPage = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <HelmetProvider>
      <Helmet>
        <title>Social | RegAI</title>
        <meta name="description" content="Ultimi aggiornamenti dai canali social di RegAI." />
        <link rel="canonical" href="https://regai.it/social" />
      </Helmet>

      <MediaProvider>
        <ContentProvider>
          <div className="min-h-screen">
            <a href="#main-content" className="skip-link">
              Salta al contenuto principale
            </a>

            <Navbar />

            <main id="main-content">
              <SocialHighlights />
            </main>

            <Footer />
          </div>
        </ContentProvider>
      </MediaProvider>
    </HelmetProvider>
  );
};

export default SocialPage;

